import React, { useState } from 'react';
import { Mail, Phone, MessageSquare } from 'lucide-react';

const ContactSection: React.FC = () => {
  const [showChat, setShowChat] = useState(false);

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Haben Sie Fragen?
          </h2>
          <p className="text-xl text-gray-600">
            Unser Team steht Ihnen gerne zur Verfügung
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {/* Email */}
          <a 
            href="mailto:aiko@ki-navigatoren.de" 
            className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
          >
            <div className="flex flex-col items-center text-center">
              <Mail className="w-10 h-10 text-[#2574B5] mb-4" />
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                E-Mail
              </h3>
              <p className="text-gray-600">
                aiko@ki-navigatoren.de
              </p>
            </div>
          </a>

          {/* Phone */}
          <a 
            href="tel:+4973638189409" 
            className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
          >
            <div className="flex flex-col items-center text-center">
              <Phone className="w-10 h-10 text-[#2574B5] mb-4" />
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Telefon
              </h3>
              <p className="text-gray-600">
                +49 (0) 7363 8189409
              </p>
            </div>
          </a>

          {/* Chat */}
          <button 
            onClick={() => setShowChat(true)}
            className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
          >
            <div className="flex flex-col items-center text-center">
              <MessageSquare className="w-10 h-10 text-[#2574B5] mb-4" />
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Live-Chat
              </h3>
              <p className="text-gray-600">
                Mo-Fr, 9-17 Uhr
              </p>
            </div>
          </button>
        </div>

        {showChat && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg max-w-lg w-full p-6 relative">
              <button
                onClick={() => setShowChat(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Live-Chat
              </h3>
              
              <p className="text-gray-600 mb-4">
                Unser Chat-System wird in Kürze verfügbar sein. 
                Bis dahin erreichen Sie uns per E-Mail oder Telefon.
              </p>
              
              <div className="flex justify-end">
                <button
                  onClick={() => setShowChat(false)}
                  className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
                >
                  Schließen
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ContactSection;